import validation, { ValidateEmail } from '@/helpers/validation';

export interface Friend {
  name?: string;
  email?: string;
}

function Valid(f: Friend): boolean {
  if (!f.name || !f.email) { return false; }
  return ValidateEmail(f.email);
}

function ValidFriends(fs: Friend[]): boolean {
  for (const f of fs) {
    if (Valid(f)) { return false; }
  }
  return true;
}

export default {
  Valid,
  ValidFriends
};
